module.exports = __webpack_public_path__ + "img/img.d40425fe.png";